import { CommonEnums } from '../common.enums';

export class AttributeCarryForward {
    obj_Id: number;
    obj_Nm: string;
    attr_Id: number;
    attrNm: string;
    parent_Attr_Id: number;
    attrFullNm: string;
    attrType_Cd: string;
    attrDTyp_Id: number;
    attrDTypNm: string;
    attrPrec: number;
    attrScale: number;
    explodeFlag: string;
    text: string;
    type: string;
    attrDesc: string;
    clevel: number;
    name: string;
    notNullValue: boolean;
    showUnderline: boolean;
    attrKeyTyp_Id: number;
    attrKeyTyp_Name: string;
    paramDTyp_Name: string;;
    notNullFlag: number;
    lnk_Obj_Id: number;
    lnk_Attr_Id: number;
    colformat: string;
    checked: string; 
    description: string;
    paramDesc: string; 
    maxFlag: string;
    isMaxEditFlag: string;

    constructor() {
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
		this.obj_Nm = CommonEnums.defaults.STRING_EMPTY;
		this.attr_Id = CommonEnums.defaults.LONG_VAL;
		this.attrNm = CommonEnums.defaults.STRING_EMPTY;
		this.parent_Attr_Id = CommonEnums.defaults.LONG_VAL;
		this.attrFullNm = CommonEnums.defaults.STRING_EMPTY;
		this.attrType_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.attrDTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.attrDTypNm = CommonEnums.defaults.STRING_EMPTY;
		this.attrPrec = CommonEnums.defaults.DEFAULT_NUM_VAL_INT;
		this.attrScale = CommonEnums.defaults.DEFAULT_NUM_VAL_INT;
		this.explodeFlag = CommonEnums.defaults.STRING_VAL_NO;
		this.text= CommonEnums.defaults.STRING_EMPTY;
		this.type = CommonEnums.defaults.ATTRTYPE_CD;
		this.attrDesc = CommonEnums.defaults.STRING_EMPTY;
		this.clevel = CommonEnums.defaults.DEFAULT_NUM_VAL_INT;
		this.name = CommonEnums.defaults.STRING_EMPTY;
		this.notNullValue = false;
		this.attrKeyTyp_Id = CommonEnums.defaults.DEFAULT_NUM_VAL_INT;
		this.attrKeyTyp_Name = CommonEnums.defaults.STRING_EMPTY;
		this.showUnderline = true;
		this.paramDTyp_Name = CommonEnums.defaults.STRING_EMPTY;
		this.notNullFlag = CommonEnums.defaults.DEFAULT_NUM_VAL_INT;
		this.lnk_Obj_Id = CommonEnums.defaults.LONG_VAL; 
		this.lnk_Attr_Id = CommonEnums.defaults.LONG_VAL;
		this.checked = CommonEnums.defaults.STRING_EMPTY;
		this.description = CommonEnums.defaults.STRING_EMPTY;
		this.paramDesc = CommonEnums.defaults.STRING_EMPTY;
		this.colformat = CommonEnums.defaults.STRING_EMPTY;
		this.maxFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.isMaxEditFlag = CommonEnums.defaults.STRING_VAL_NO;
    }
}